import { selfExclusionsConstants } from './selfExclusionsConstants';
import {userConstants} from "../../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  logItems: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "id",
  sortDirection: "desc",
  startDate: null,
  endDate: null,
  total: 0,
  logTotal: 0,
  error: '',
  query: "",
  inProgress: true,
});

export function player_exclusion_selfExclusions(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case selfExclusionsConstants.SELF_EXCLUSIONS_LIST_REQUEST:
    case selfExclusionsConstants.SELF_EXCLUSIONS_LOAD_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        logTotal: 0,
        inProgress: true,
      };
    case selfExclusionsConstants.SELF_EXCLUSIONS_LIST_SUCCESS: {
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.selfExclusions.rows ? action.selfExclusions.rows : [],
        total: action.selfExclusions.total ? action.selfExclusions.total : 0,
        inProgress: false,
      };
    }
    case selfExclusionsConstants.SELF_EXCLUSIONS_LOAD_SUCCESS: {
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        logItems: action.selfExclusions.rows ? action.selfExclusions.rows : [],
        logTotal: action.selfExclusions.total ? action.selfExclusions.total : 0,
        inProgress: false,
      };
    }
    case selfExclusionsConstants.SELF_EXCLUSIONS_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case selfExclusionsConstants.SELF_EXCLUSIONS_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case selfExclusionsConstants.SELF_EXCLUSIONS_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.startDate !== action.pagination.startDate
        || state.endDate !== action.pagination.endDate
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        startDate: action.pagination.startDate,
        endDate: action.pagination.endDate,
        shouldReload
      };
    }

    case selfExclusionsConstants.SELF_EXCLUSIONS_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case selfExclusionsConstants.SELF_EXCLUSIONS_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.selfExclusions],
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(t => t.id === action.selfExclusions.id ? action.selfExclusions : t)
      }
    case selfExclusionsConstants.SELF_EXCLUSIONS_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }
    default:
      return state
  }
}
